module.exports = __webpack_public_path__ + "static/img/12.b48a195.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/12.png
// module id = 6O/3
// module chunks = 0